import { render, staticRenderFns } from "./FooterMenuItem.vue?vue&type=template&id=2b5426b3&"
import script from "./FooterMenuItem.vue?vue&type=script&lang=ts&"
export * from "./FooterMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./FooterMenuItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports